import { useCallback, useEffect, useRef } from 'react'
import RouteContainer from '../../common/styles/RouteContainer'
import IndexSearchBar from './card/IndexSearchBar'
import IndexProfilesCard from './card/IndexProfilesCard'
import IndexTipsCard from './card/IndexTipsCard'
import IndexLibraryCard from './card/IndexLibraryCard'
import IndexSummaryCard from './card/IndexSummaryCard'
import RowSpacer from '../../common/styles/RowSpacer'
import IndexPopularBookCard from './card/IndexPopularBookCard'
import IndexAfterReleaseCard from './card/IndexAfterReleaseCard'
import BookRecommendersCard from "../community/book-recommendations/BookRecommendersCard";
import { SearchBarHandle } from '../search/searchBar/SearchBar'

const IndexRoute = () => {
	const searchBarRef = useRef<SearchBarHandle>(null)

	const handleKeyDown = useCallback((e: KeyboardEvent) => {
		if ((e.ctrlKey || e.metaKey) && e.key === 'f') {
			e.preventDefault()
			searchBarRef.current?.focus()
		}
	}, [])

	useEffect(() => {
		document.addEventListener('keydown', handleKeyDown)
		return () => document.removeEventListener('keydown', handleKeyDown)
	}, [handleKeyDown])

	return (
		<RouteContainer>
			<RowSpacer/>

			<IndexAfterReleaseCard />
			<RowSpacer size={40} />

			<IndexSearchBar ref={searchBarRef} />
			<RowSpacer size={60} />

			<IndexSummaryCard />
			<RowSpacer size={40} />

			<IndexPopularBookCard />
			<RowSpacer size={40} />

            <BookRecommendersCard purpose={'index'}/>
			<RowSpacer size={40} />

			{/* <IndexProfilesCard /> */}
			{/* <RowSpacer size={40} /> */}

			<IndexTipsCard />
			<RowSpacer size={40} />

			<IndexLibraryCard />
			<RowSpacer size={40} />
		</RouteContainer>
	)
}

export default IndexRoute
